import { Spin } from 'antd';

/**
 * Standard loading spinner for page loading, not used for smaller spinner on specific section.
 */
const PageLoadingSpinner = () => (
  <div style={{ margin: '20px 0', textAlign: 'center' }}>
    <Spin size="large" />
  </div>
);

export default PageLoadingSpinner;
